import { useState } from "react";
import { IoChevronBack, IoSearchOutline } from "react-icons/io5";
import { useAppDispatch } from "../../../utils/hooks";
import ContactList from "./ContactList";
import { useNavigate } from "react-router-dom";
import { PiUsersThree } from "react-icons/pi";
import { updateCreateGroupData } from "../../../store/Slices/CreateGroupSlice";
import { useWebsiteSettings } from "../../../store/api/useWebsiteSettings";
import TextTranslate from "../../../utils/TextTranslate";
import { useTranslateText } from "../../../hooks/useTranslateText";
import { RxCross2 } from "react-icons/rx";
import { IoChevronForward } from "react-icons/io5";

const groupClass =
  "overflow-hidden rounded-2xl bg-primary shadow-sm ring-1 ring-black/[0.04] dark:ring-white/[0.06]";

export default function Contacts() {
  const [searchUser, setsearchUser] = useState("");
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { data: websiteSettings } = useWebsiteSettings();
  const translate = useTranslateText();

  return (
    <div className="relative flex h-[100dvh] w-full flex-col overflow-hidden bg-secondary pb-[calc(3.25rem+env(safe-area-inset-bottom))] shadow-inner lg:max-w-md lg:pb-0">
      <div className="sticky top-0 z-20 shrink-0 border-b border-black/[0.06] bg-secondary/85 backdrop-blur-xl dark:border-white/[0.08]">
        <div className="flex items-center justify-between px-3 py-3">
          <button
            type="button"
            aria-label="Back"
            className="grid h-9 w-9 place-content-center rounded-full bg-black/[0.06] text-darkText transition active:scale-95 dark:bg-white/10"
            onClick={() => navigate(-1)}
          >
            <IoChevronBack className="text-xl" />
          </button>
          <span className="text-[17px] font-semibold tracking-tight text-darkText">
            <TextTranslate text="New Chat" />
          </span>
          <div className="h-9 w-9" aria-hidden />
        </div>

        <div className="px-4 pb-3">
          <div className="relative">
            <IoSearchOutline className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-lg text-lightText" />
            <input
              value={searchUser}
              onChange={(e) => setsearchUser(e.target.value)}
              className="w-full rounded-[10px] border-0 bg-black/[0.06] py-2.5 pl-10 pr-10 text-[15px] text-darkText outline-none placeholder:text-lightText dark:bg-white/[0.1]"
              type="search"
              enterKeyHint="search"
              placeholder={translate("Search User")}
            />
            {searchUser.length > 0 && (
              <button
                type="button"
                aria-label="Clear"
                onClick={() => setsearchUser("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-lightText"
              >
                <RxCross2 className="text-lg" />
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto px-4 pb-10 pt-4">
        <div className={`${groupClass} mb-5`}>
          <button
            type="button"
            onClick={() => {
              dispatch(
                updateCreateGroupData({
                  createNewGroup: true,
                  user_id: [],
                  existing_member_user_id: [],
                  group_name: "",
                  group_description: "",
                }),
              );
              navigate("/add-member-to-group");
            }}
            className="flex w-full items-center gap-3 px-3 py-3 text-left transition active:bg-black/[0.03] dark:active:bg-white/[0.04]"
          >
            <div className="grid h-12 w-12 place-content-center rounded-full bg-themeColor text-white">
              <PiUsersThree className="h-6 w-6" />
            </div>
            <div className="min-w-0 flex-1 text-[16px] font-semibold text-darkText">
              <TextTranslate text="New Group" />
            </div>
            <IoChevronForward className="shrink-0 text-lg text-lightText" />
          </button>
        </div>

        <div className="mb-1.5 px-1 text-[13px] font-medium uppercase tracking-wide text-lightText">
          <TextTranslate text="Contact on" />{" "}
          {websiteSettings?.data.app_name ?? ""}
        </div>
        <div className={groupClass}>
          <ContactList searchUser={searchUser} />
        </div>
      </div>
    </div>
  );
}
